export function formHandler(options) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    return {
        form: { ...options.fields },
        originalFields: { ...options.fields },
        errors: {},
        isShown: false,
        async submitForm() {
            try {
                const response = await fetch(options.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': csrfToken,
                    },
                    body: JSON.stringify(this.form),
                });

                const data = await response.json();

                if (!response.ok) {
                    if (data.errors) {
                        this.errors = data.errors;
                    }
                } else {
                    this.resetForm({ message: data.message })
                }
            } catch (e) {
                console.error('Помилка з’єднання з сервером.', e);
            }
        },
        resetForm({message}) {
            this.form = { ...this.originalFields };
            this.errors = {};
            this.$refs.close.click();

            this.$nextTick( () => {
                const stars = this.$refs.star.querySelectorAll('.rating-control__star');

                if  (stars.length) {
                    this.updateSelectedStars(stars, this.form.rating)
                }

                window.ToastManager.createToast(message, 'success');
            })
        },
        updateSelectedStars(stars, input) {
            const lastActiveIndex = parseInt(input) - 1

            stars.forEach((star, i) => {
                if (i <= lastActiveIndex) {
                    star.classList.add('rating-control__star--selected')
                } else {
                    star.classList.remove('rating-control__star--selected')
                }
            })
        }
    };
}